import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { createApiClient } from './client';

interface LoginWithEmailParams {
    email: string;
    password: string;
}

interface LoginWithMfaParams {
    code: string;
    oob_code: string;
    mfa_token: string;
}

interface SignupParams {
    email: string;
    password: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
}

interface MfaListAuthenticatorsParams {
    mfa_token: string;
}

interface MfaSendCodeParams {
    authenticator_id: string;
    mfa_token: string;
}

interface ForgotPasswordParams {
    email: string;
}

interface RefreshTokenParams {
    refresh_token: string;
}

export class NativeAuthService {
    private readonly apiClient;

    constructor(isOrder: boolean) {
        this.apiClient = createApiClient(isOrder);
    }

    async loginWithEmail(params: LoginWithEmailParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `api/login`,
            body: params,
        });
        return await this.apiClient.ExecuteRequest(request);
    }

    async loginWithMfa(params: LoginWithMfaParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `api/login`,
            headers: [params.oob_code, params.mfa_token],
            body: params.code,
        });

        return await this.apiClient.ExecuteRequest(request);
    }

    async signup(params: SignupParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `signup`,
            body: params,
        });

        return await this.apiClient.ExecuteRequest(request);
    }

    async mfaListAuthenticators(params: MfaListAuthenticatorsParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `mfa`,
            headers: params,
        });

        return await this.apiClient.ExecuteRequest(request);
    }

    async mfaSendCode(params: MfaSendCodeParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `mfa`,
            headers: params.mfa_token,
            body: params.authenticator_id,
        });

        return await this.apiClient.ExecuteRequest(request);
    }

    async forgotPassword(params: ForgotPasswordParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `user/forgot-password`,
            body: params,
        });

        return await this.apiClient.ExecuteRequest(request);
    }

    async refreshToken(params: RefreshTokenParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Post,
            endpoint: `session/refresh-token`,
            body: params,
        });

        return await this.apiClient.ExecuteRequest(request);
    }
}
